<template>
  <div class="progress-bar" :style="stylesProgressBar">
    <div class="indicator" ref="indicator" :style="stylesIndicator"></div>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    height: {
      default: '5px',
      type: String
    },
    indicatorColor: {
      default: '#21CE99',
      type: String
    },
    progress: String,
    progressBarColor: {
      default: '#ccc',
      type: String
    }
  },
  computed: {
    progressPercent: function () {
      if (parseInt(this.progress) >= 0 && parseInt(this.progress) <= 100) {
        return `${parseInt(this.progress) - 100}%`
      }
    },
    stylesIndicator: function () {
      return {
        backgroundColor: this.indicatorColor,
        height: this.height,
        transform: `translateX(${this.progressPercent})`
      }
    },
    stylesProgressBar: function () {
      return {
        backgroundColor: this.progressBarColor
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .progress-bar {
    width: 100%;
    position: relative;
    overflow: hidden;
    border-radius: 2.5px;
  }

  .indicator {
    width: 100%;
    transform: translateX(-100%);
    transition: transform 500ms ease;
  }
</style>


// WEBPACK FOOTER //
// src/js/components/ProgressBar.vue